// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1RmVh","msgContainer":"styles_msgContainer__2dxNd"};